import styled from "styled-components"

export const SimpleButton = styled.a`
  color: ${({ color }) => color || "var(--black)"};
  background: ${({ background }) => background || "var(--thaiChili)"};
  padding: ${({ padding }) => padding || "9px 15px"};
  font-size: ${({ fontSize }) => fontSize || "15px"};
  margin: ${({ margin }) => margin || "0"};
  border: ${({ border }) => border || "0"};
  border-radius: var(--buttonBorderRadious);
  cursor: pointer;
  transition: 0.3s;
  font-family: "Oswald", sans-serif;
  height: ${({ height }) => height || "inherit"};
  &:hover {
    background: var(--secondaryColor);
    color: var(--white);
  }
  @media (max-width: 768px) {
    margin: 0px;
  }
`

export const OnClickButton = styled.button`
  cursor: pointer;
  padding: ${({ padding }) => padding || "12px 30px"};
  background: ${({ background }) => background || "var(--machuPiccuGardens)"};
  color: ${({ color }) => color || "var(--white)"};
  border-radius: 6px;
  text-align: center;
  outline: 0;
  border: 0;
  font-family: "Lato", sans-serif;
`
